export const infraConfig = {
    apiEndpoint : "https://minsidavh-be.azurewebsites.net/api1",
    usePort: false,
    clientId: 'f8c2f6b2-b975-4477-8b8f-a37d00f3ee1e', 
    identityServerEndpoint : "https://login.microsoftonline.com/vastanhede.onmicrosoft.com/v2.0",
    documentsUrl: "https://minsidavh-docs.azurewebsites.net"
};

